import type { AnyFormApi } from "@tanstack/react-form";
import type { FormEvent } from "react";

/**
 * The one submit path: `<form onSubmit={formSubmitHandler(form)}>` plus a `type="submit"` button (inside
 * the form, or outside it linked with the HTML `form="<id>"` attribute). Enter and click both reach it
 * exactly once, so never add an `onClick` that also calls `handleSubmit`.
 */
export const formSubmitHandler = (form: AnyFormApi) => (event: FormEvent<HTMLFormElement>) => {
  event.preventDefault();
  event.stopPropagation();
  void form.handleSubmit();
};
